import React, { Component } from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { HashLink as Link } from 'react-router-hash-link';
import Popup from 'reactjs-popup';
import { formatName } from '../../utils/spaUtils';
import MediaQuery from 'react-responsive';
import './breadcrumb.css';

const contentStyle = {
    color: '#000',
    width: '400px',
    zIndex: 990,
    backgroundColor: '#e5f3fd',
    padding: '15px',
};
var lastScrollTop = 0;

class SpaBreadcrumb extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cart: [...props.cart],
        };
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event) {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        let breadcrumbEle = document.getElementById('mob-breadcrumb-ref');
        if (breadcrumbEle) {
            if (st > lastScrollTop) {
                breadcrumbEle.style.display = 'none';
            } else {
                breadcrumbEle.style.display = 'block';
            }
        }

        lastScrollTop = st <= 0 ? 0 : st;
    }

    closeCartWindow = () => {
        this.refs.cart.closePopup();
    };

    getItems() {
        let { items = [] } = this.props;
        return items.map((item) => (
            <li className="breadcrumb-item" key={item.label}>
                <Link
                    className="button-link spa-breadcrumb-label font-size-p2 gotham-xn-book"
                    aria-label={`Go to ${item.label}`}
                    data-test-id="spa-bread-crumb-label"
                    to={item.link}>
                    {item.label}
                </Link>
            </li>
        ));
    }
    componentWillReceiveProps(next) {
        if (this.state.cart.length !== this.props.cart.length) {
            if (this.props.cart.length > 0) this.refs.cart.openPopup();
            this.setState({ cart: [...next.cart] });
        }
    }

    get CartTrigger() {
        return (
            <button
                disabled={this.props.cart && this.props.cart.length === 0}
                className="button-link button secondary-btn"
                data-test-id="view-cart"
                aria-expanded={false}>
                {this.props.cart.length === 0 ? (
                    <label className="font-size-p2 gotham-xn-medium   ">Cart is Empty</label>
                ) : this.props.cart.length === 1 ? (
                    <label className="font-size-p2 gotham-xn-medium title-hover view-cart-hover">
                        View Cart - {this.props.cart.length} item
                        <svg
                            alt="open"
                            role="img"
                            focusable="false"
                            className="svg-icon svg-icon-down-arrow">
                            <use xlinkHref="#icon-down-arrow"></use>
                        </svg>
                    </label>
                ) : (
                    <label className="font-size-p2 gotham-xn-medium title-hover view-cart-hover">
                        View Cart - {this.props.cart.length} items
                        <svg
                            alt="open"
                            role="img"
                            focusable="false"
                            className="svg-icon svg-icon-down-arrow">
                            <use xlinkHref="#icon-down-arrow"></use>
                        </svg>
                    </label>
                )}
            </button>
        );
    }

    get CartContent() {
        let { cart = [] } = this.props;
        return (
            <div className="cart-items-container" data-test-id="reservation-pop-up-container">
                <span className="visuallyhidden">View Cart - Expanded</span>
                <div className="cart-warning row" data-test-id="reservation-pop-up-title row">
                    <div className="col-md-2 col-xs-2 col-sm-2">
                        <span className="pc-icons warning-triangle-bang-24"></span>
                    </div>
                    <div className="col-md-10 col-xs-10 col-sm-10">
                        <span
                            className="card-text font-size-p2 gotham-book"
                            data-test-id="reserve-card-text">
                            Reservations are not confirmed and can be reserved by other guests until
                            payment is received
                        </span>
                    </div>
                </div>
                <hr className="cart-hr"></hr>
                <div className="cart-items-container scrollbar" id="ex3">
                    <div className="contents-scroll">
                        {cart.length > 0
                            ? cart.map((item) => <CartItem key={item.treatmentId} item={item} />)
                            : null}
                    </div>
                </div>
            </div>
        );
    }
    render() {
        let { cart = [] } = this.props;
        return (
            <div id="spa-bread-crumb" className="bread-crumb-container spa-bread-crumb">
                <span
                    className="visuallyhidden"
                    role="status">{`Shopping cart updated ${this.props.cart.length} items`}</span>
                <Breadcrumb as="div" aria-label="" className="spa-bread-crumb container">
                    <MediaQuery and maxDeviceWidth={767}>
                        {(matches) => {
                            if (matches) {
                                return null;
                            } else {
                                return this.getItems();
                            }
                        }}
                    </MediaQuery>
                    <li className="shopping-cart" data-test-id="shopping-cart">
                        {this.props.items.length >= 1 ? (
                            <div
                                id="mob-breadcrumb-ref"
                                style={{ display: 'none' }}
                                className="row breadcrumb-mob hidden-sm-up">
                                <div className="col text-center">
                                    <Breadcrumb
                                        as="div"
                                        aria-label=""
                                        className="spa-bread-crumb container  font-size-p2 gotham-xn-book">
                                        <MediaQuery and maxDeviceWidth={767}>
                                            {this.getItems()}
                                        </MediaQuery>
                                    </Breadcrumb>
                                </div>
                            </div>
                        ) : null}

                        <dl className="shopping-cart-label-dl">
                            <dt className="shopping-cart-label-dt">
                                {' '}
                                <span className="shopping-cart-label font-size-p2 gotham-xn-medium">
                                    Shopping Cart{' '}
                                </span>
                            </dt>
                            <dd className="shopping-cart-label-dd">
                                <div className="shopping-cart-trigger" role="text">
                                    <Popup
                                        ref="cart"
                                        contentStyle={contentStyle}
                                        className="cart-pop-up"
                                        trigger={this.CartTrigger}
                                        closeOnDocumentClick={true}
                                        defaultOpen={false}
                                        position="bottom right">
                                        <div className="cart-header hidden-sm-up">
                                            <div className="col-md-6 col-xl-6 col-sm-6">
                                                <label
                                                    for="Shopping Cart"
                                                    id="shopping-cart-label"
                                                    className="font-size-p1 gotham-xn-medium">
                                                    Shopping Cart
                                                </label>
                                            </div>
                                            <div className="col-md-6 col-xl-6 col-sm-6">
                                                <span className="cart-close-icon">
                                                    <svg
                                                        onClick={this.closeCartWindow}
                                                        role="button"
                                                        focusable="false"
                                                        className="svg-icon svg-icon-close-x">
                                                        <use
                                                            xlinkHref="#icon-close-x"
                                                            data-test-id="link-close-arrow"></use>
                                                    </svg>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="cart-container ">{this.CartContent}</div>
                                        <div className="pay-now-button-container padding-10 text-center hidden-xs-down">
                                            <Link smooth to="/#paymentform">
                                                <button
                                                    className="button  primary-btn padding-dot4-dot5  font-size-p2 gotham-xn-book"
                                                    data-test-id="pay-now">
                                                    Pay Now
                                                </button>
                                            </Link>
                                        </div>
                                        <div
                                            className="cart-continue-text Reserve-card-times-text continue-shopping hidden-xs-down text-center font-size-p1 gotham-book"
                                            data-test-id="continue-shopping">
                                            <Link smooth to="/spaservices">
                                                Continue Shopping
                                            </Link>
                                        </div>
                                        <div className="cart-footer hidden-sm-up">
                                            <Link className="paynow-btn " smooth to="/#paymentform">
                                                <button
                                                    className="button  primary-btn padding-dot4-dot5  font-size-p0 gotham-medium"
                                                    data-test-id="pay-now">
                                                    Pay Now
                                                </button>
                                            </Link>
                                            <Link
                                                className="continue-shopping font-size-p1 gotham-book"
                                                smooth
                                                to="/spaservices">
                                                Continue Shopping
                                            </Link>
                                        </div>
                                    </Popup>
                                </div>
                            </dd>
                        </dl>
                    </li>
                </Breadcrumb>
            </div>
        );
    }
}

const CartItem = (props) => {
    let { item } = props;
    let userName = item.PassengerDetail.Name;
    let _label = formatName(`${userName.FirstName} ${userName.LastName}`);

    return (
        <div className="cart-item-container">
            <p className="cart-item-name no-pad-margin font-size-p2 gotham-xn-medium">
                {item.treatmentDesc}
            </p>
            <span className="cart-item-time font-size-p0 gotham-xn-medium">
                {item.serviceGroup === 'relaxationareas' ? 'All-Day' : item.formattedTime}
            </span>{' '}
            |<span className="cart-item-date font-size-p0 gotham-xn-medium">{item.formatDate}</span>
            <span
                style={{ paddingLeft: '20px' }}
                className="cart-item-guest font-size-p0 gotham-xn-medium">
                {_label}
            </span>
        </div>
    );
};

export default SpaBreadcrumb;
